import {
  ODataHeader,
  ODataString,
} from "pbas-vue-components";

function getHeaders() {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Name"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
}
export default getHeaders;
